export const URI_AUTH_FORGOTPASSWORD = "/api/auth/forgot-password";
export const URI_AUTH_REFRESH = "/api/auth/refresh";
export const URI_AUTH_RESETPASSWORD = "/api/auth/reset-password/:hash";
export const URI_AUTH_SIGNIN = "/api/auth/sign-in";
